import { Box, Divider, Typography } from "@mui/material";
import useColors from "../../../../../api/hooks/useColors";

import { useSearchParams } from "react-router-dom";
import useAPI from "../../../../../api/hooks/useAPI";
import { QueryParam } from "../../../../../utils/constants";
import { getPluralizedTitle } from "../../utils";
import { EntityTypeInfo } from "../constants";
import CardHeaderSection from "./CardHeaderSection";
import { CardMainSection } from "./CardMainSection";
import { ViewButton } from "./ViewButton";

export const CARD_WIDTH = 413;

// TODO - Implement sources in https://linear.app/breeze-security/issue/DEV-2194/add-granular-counts-table-in-entity-type-overview-card
const SourcesSection = ({ colors }) => (
  <Box
    height="112px"
    display="flex"
    flexDirection="column"
    gap={1}
    sx={{
      borderRadius: "12px",
      boxShadow: colors.entity_type_sources_card_box_shadow,
      padding: 2,
    }}
  >
    <Box height="40px" paddingBottom="8px">
      logos
    </Box>
    <Box height="32px">
      <Typography variant="caption">3/37</Typography>
    </Box>
  </Box>
);

export default function EntityTypeOverviewCard({
  entityType,
  entityTypeMetadata,
  entitiesAreLoading,
  showSources = false,
}) {
  const colors = useColors();
  const { trackEvent } = useAPI();
  const [, setSearchParams] = useSearchParams();
  const entityTypeInfo = EntityTypeInfo[entityType];
  if (entityTypeInfo == null) return null;

  const handleViewClick = () => {
    const params = new URLSearchParams({
      [QueryParam.environmentType]: entityType,
    });
    setSearchParams(params);
    trackEvent(
      `User clicked "${entityType}" entity type card to view the entities`
    );
  };

  return (
    <Box
      display="flex"
      flexDirection="column"
      width={`${CARD_WIDTH}px`}
      minWidth={`${CARD_WIDTH}px`}
      gap={2}
      sx={{
        borderRadius: "24px",
        boxShadow: colors.entity_type_card_box_shadow,
        padding: "24px",
      }}
    >
      <CardHeaderSection
        colors={colors}
        entityTypeInfo={entityTypeInfo}
        entityTypeMetadata={entityTypeMetadata}
      />
      <Divider />
      {showSources && <SourcesSection colors={colors} />}
      <CardMainSection entityTypeMetadata={entityTypeMetadata} />
      <ViewButton
        colors={colors}
        title={getPluralizedTitle(
          entityTypeInfo.title,
          entityTypeMetadata.total_entities
        )}
        onClick={handleViewClick}
        fetchedEntitiesAreLoading={entitiesAreLoading}
      />
    </Box>
  );
}
